<template>
  <div>
    <template v-if="configData.TitleFirstRow || configData.Title">
      <div v-if="configData?.TitleStyle?.toLowerCase() === 'boxed'">
        <!-- Hide content for screen reader due to issues and read an aria label -->
        <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
        <h1 class="flex flex-col gap-8" :aria-label="headingLabel">
          <BoxedText aria-hidden="true">
            {{ configData.Title || configData.TitleFirstRow }}
          </BoxedText>

          <BoxedText v-if="configData.TitleSecondRow" aria-hidden="true">
            {{ configData.TitleSecondRow }}
          </BoxedText>
        </h1>
      </div>
      <div v-else>
        <h2 class="heading-xs">{{ configData.TitleFirstRow }}</h2>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    /**
     * @deprecated The field should not be used any more and existing pages should be migrated to use TitleFirstRow.
     */
    Title?: string;
    TitleFirstRow: string;
    TitleSecondRow?: string;
    TitleStyle?: string;
    FullBackground?: boolean;
  };
}

const props = defineProps<Props>();

const headingLabel = computed(() =>
  [
    props.configData.Title || props.configData.TitleFirstRow,
    props.configData.TitleSecondRow,
  ]
    .filter(Boolean)
    .join(' '),
);

if (props.configData.Title) {
  console.warn('Use of depricated "Title" field in markup "SectionHeaderH1"');
}
</script>

<style scoped></style>
